import ReCAPTCHA from 'react-google-recaptcha';
import { Component } from 'react';
import { observer } from 'mobx-react';

const RecaptchaBadge = observer(
  class RecaptchaBadge extends Component {
    componentDidMount() {
      window.recaptcha.instances[$(this.badge).closest('form').attr('id')] =
        this;
    }

    componentWillUnmount() {
      if (this.recaptchaRef) {
        this.recaptchaRef.reset();
      }
    }

    toggle = () => {
      this.recaptchaRef.execute();
    };

    onCaptchaSuccess = (token) => {
      if (this.props.successCallback) this.props.successCallback(token);

      document.dispatchEvent(
        new CustomEvent('recaptchaSuccess', { detail: { token: token } })
      );
    };

    render() {
      return (
        <div ref={(el) => (this.badge = el)}>
          <input
            className='recaptcha_token'
            name='recaptcha[token]'
            type='hidden'
          />

          <ReCAPTCHA
            badge='inline'
            grecaptcha={window.grecaptcha}
            onChange={this.onCaptchaSuccess}
            ref={(el) => {
              this.recaptchaRef = el;
            }}
            sitekey={recaptchaV2SiteKey}
            size='invisible'
          />
        </div>
      );
    }
  }
);

export default RecaptchaBadge;
